<template>
  <div class="header-form-home">
    <Layout>
      <PageHeader :items="items" />
      <div class="container-app">
        <div class="content-title">
          <span class="title-card-app">Informe Hogares</span>
          <span>
            <router-link
              size="sm"
              class="p-0 ml-2 btn-link-add"
              :to="{ name: 'home' }"
            >
              <b-icon class="icon-plus" icon="arrow90deg-left"></b-icon>
            </router-link>
          </span>
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <div class="card-app mb-3">
              <div class="mb-1 title-card-app">Consultar hogar</div>
              <div class="subtitle-card-app mb-2"
                >Puede realizar la consulta ingresando el Código del hogar ó la
                dirección</div
              >
              <div class="row">
                <div class="col-lg-5">
                  <div class="form-group">
                    <label for="">Código Hogar</label>
                    <input
                      type="address"
                      v-model="selectCodHogar"
                      class="form-control form-control-home"
                      placeholder="Código Familia"
                      readonly
                      @click="$bvModal.show('modal-codHogar')"
                    />
                  </div>
                </div>
                <div class="col-lg-5">
                  <div class="form-group">
                    <label for="">Dirección</label>
                    <input
                      type="address"
                      v-model="text"
                      class="form-control form-control-home"
                      placeholder="Ingresar Dirección"
                      @click="$bvModal.show('address-modal')"
                      readonly
                    />
                  </div>
                </div>
                <div class="col-lg-2 col-md-2 col-12 pt-lg-3 pt-md-3">
                  <b-button
                    style="height: 32px;margin-top: 8px;"
                    v-if="dataFamilies.count > 0"
                    pill
                    class="float-right button-search"
                    size="sm"
                    variant="primary"
                    @click="cleanInput"
                  >
                    Limpiar
                  </b-button>
                </div>
              </div>
            </div>
            <div class="card-app">
              <div class="mb-1 title-card-app">Resultado consulta hogar</div>
              <hr />
              <div v-if="loading">
                <b-row>
                  <b-col md="12">
                    <div class="text-center-homeReport">
                      <b-spinner
                        label="Spinning"
                        style="color: #195db2; width: 3rem; height: 3rem"
                      ></b-spinner>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <div class="box-card-search" v-else>
                <div class="overlay-card-search">
                  <span class="content-icon">
                    <i class="fas fa-exclamation-triangle"></i>
                  </span>
                  <span class="title-card-search"
                    >No se encontraron datos en la búsqueda</span
                  >
                  <span class="subtitle-card-search"
                    >Realiza una nueva consulta</span
                  >
                </div>
              </div>
              <div v-if="dataFamilies.count > 0 && infoResultsSeacrh">
                <b-card
                  no-body
                  class="mb-1"
                  v-for="(family, key) in dataFamilies.results"
                  :key="`fam-${family.id}-${key}`"
                >
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-row
                      align-v="center"
                      class="row-family"
                      v-b-toggle="`accordion-fam-${family.id}`"
                    >
                      <b-col
                        v-if="selectCodHogar"
                        cols="1"
                        class="radio-family"
                      >
                        <b-form-radio
                          id="direccion"
                          v-model="text"
                          name="direccion"
                          :value="family.direccion"
                        >
                        </b-form-radio>
                      </b-col>
                      <b-col v-else cols="1" class="radio-family">
                        <b-form-radio
                          id="hogar"
                          v-model="selectCodHogar"
                          name="codigo_familia"
                          :value="family.codigoFamilia"
                        ></b-form-radio>
                      </b-col>

                      <input-multi-select
                        style="font-weight: bold;"
                        class="inputCodFamilie"
                        cols="3"
                      >
                        Código de Familia:
                        <span
                          style="font-weight: 50;"
                          class="spanInfoFamilie"
                          >{{ family.codigoFamilia }}</span
                        >
                        <br />
                        Dirección:
                        <span
                          style="font-weight: 50;"
                          class="spanInfoFamilie"
                          >{{ family.direccion }}</span
                        >
                      </input-multi-select>
                      <b-col sm class="text-right"
                        ><span style="color: rgb(242, 140, 2)"
                          >({{ family.personas.length }} Integrantes)</span
                        ></b-col
                      >
                      <b-icon
                        align-v="center"
                        class="when-closed"
                        icon="chevron-down"
                        aria-hidden="true"
                        variant="info"
                        font-scale="1"
                      ></b-icon>
                      <b-icon
                        align-v="center"
                        class="when-opened"
                        icon="chevron-up"
                        aria-hidden="true"
                        variant="info"
                        font-scale="1"
                      ></b-icon>
                    </b-row>
                  </b-card-header>
                  <b-collapse
                    v-if="family.personas.length !== 0"
                    :id="`accordion-fam-${family.id}`"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body class="family-tree">
                      <b>Integrantes</b>
                      <b-list-group flush>
                        <b-list-group-item
                          v-for="(integrante, key) in family.personas"
                          :key="`int-${family.id}-${integrante.id}-${key}`"
                        >
                          <b>{{ key }}</b> -
                          {{
                            camelcase(
                              integrante.nombres
                                ? integrante.nombres
                                : 'Sin Nombres'
                            )
                          }}
                          <router-link
                            tag="a"
                            :to="
                              `/informe-ciudadano/${integrante.tipoid}/${
                                integrante.numeroid
                              }`
                            "
                          >
                            <b-icon
                              icon="exclamation-circle"
                              style="color: #2b85d1; scale: 1.3"
                              class="float-right button-search"
                              size="sm"
                              variant="outline-info"
                              pill
                            >
                            </b-icon>
                          </router-link>
                        </b-list-group-item>
                      </b-list-group>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </div>

            <!-- <div
            v-for="(family, key) in dataFamilies.results"
              :key="`fam-${family.id}-${key}`"
            >
            <b-collapse
                v-if="family.personas.length"
                v-model="family.isVisible"
                :id="`accordion-fam-${family.id}`"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body class="family-tree">
                  <b>Integrantes</b>
                  <b-list-group flush>
                    <b-list-group-item
                      v-for="(integrantes, key) in family.personas"
                      :key="`int-${family.id}-${key}`"
                    >
                      {{ key }} - {{ integrantes.Primer_Nombre }}
                      {{ integrantes.Segundo_Nombre }}
                      {{ integrantes.Primer_Apellido }}
                      {{ integrantes.Segundo_Apellido }}
                    </b-list-group-item>
                  </b-list-group>
                </b-card-body>
              </b-collapse>
          </div> -->
            <div v-if="!dataFamilies" class="infoError-text">
              <span>
                No se encontraron hogares relacionados con la dirección o código
                de hogar que ingreso</span
              >
              <br />
              <span>Por favor verifique los datos e intente de nuevo</span>
            </div>
          </div>
        </div>
      </div>
      <ModalAddress
        :getSearchFamilies="getSearchFamilies"
        idmodal=""
        :value.sync="text"
      />
      <b-modal id="modal-codHogar" size="lg">
        <div>
          <span class="text-direction">Código Hogar</span>
          <input
            type="text"
            v-model="selectCodHogar"
            class="form-control form-control-home"
            placeholder="ingresar Código Hogar"
            :disabled="false"
          />
          <br />
        </div>
        <template #modal-footer="{ ok }">
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <b-button
            pill
            size="sm"
            variant="primary"
            @click="
              ok()
              ContinuarHomeSelect()
              getSearchFamilies()
            "
          >
            Continuar
          </b-button>
          <!-- Button with custom close trigger value -->
        </template>
      </b-modal>
    </Layout>
  </div>
</template>
<script>
import PageHeader from '@components/page-header'
import Layout from '@layouts/main'
import ModalAddress from '@components/form/modalAddressHome'
import { familiesMethods } from '@state/helpers'

export default {
  page: {
    title: 'Reporte por hogar',
  },
  components: {
    Layout,
    PageHeader,
    ModalAddress,
  },
  data() {
    return {
      infoResultsSeacrh: true,
      loading: false,
      text: '',
      dataFamilies: [],
      loading: false,
      filterFamiliesData: [],
      formBodyHome: () => {},
      infoCodHogar: () => {},
      selectCodHogar: '',
      selectPersons: [],
      modal: false,
      editButton: false,
      items: [
        {
          text: '/',
          path: '/home',
          to: { name: 'home' },
        },
        {
          text: 'Informe Hogares',
          active: true,
        },
      ],
      extraButtons: [
        {
          variant: 'success',
          title: 'Inicio',
          to: { name: 'home' },
          icon: 'arrow90deg-left',
        },
      ],
    }
  },
  methods: {
    ...familiesMethods,
    camelcase(string) {
      let capitalize = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
      }
      const caps = string
        .split(' ')
        .map(capitalize)
        .join(' ')
      return caps
    },
    isEmptyOrSpaces(str) {
      return str === null || str.match(/^ *$/) !== null || str.trim() == ''
    },
    cleanInput() {
      this.text = ''
      this.selectCodHogar = ''
      this.infoResultsSeacrh = false
    },
    async getSearchFamilies() {
      this.loading = true
      try {
        const search = !this.isEmptyOrSpaces(this.text)
          ? { direccion: this.text }
          : !this.isEmptyOrSpaces(this.selectCodHogar)
          ? { codigoFamilia: this.selectCodHogar }
          : false
        if (search) {
          const response = !this.isEmptyOrSpaces(this.text)
            ? await this.getFamiliesByAdd(search)
            : await this.getFamiliesByCode(search)
          if (response) {
            if (response.count === 0) {
              this.$generate_noty(
                'info',
                'La dirección o código de hogar que ingresaste no esta asociado a ningun usuario'
              )
              this.cleanInput()
            }
            this.dataFamilies = response
            this.loading = false
            this.infoResultsSeacrh = true
            this.selectPersons = response.results.map((x) => {
              return {
                personas: x.personas,
                codigoFamilia: x.codigoFamilia,
              }
            })
          }
        } else {
          this.loading = false
        }
      } catch (error) {
        this.loading = false
        console.log(error)
        this.$generate_noty(
          'error',
          'Se presentó un error con el servidor por favor valida más tarde'
        )
      }
    },
    OpenModalAddress() {
      this.modal = !this.modal
    },
    ContinuarHomeSelect() {
      this.editButton = true
      this.formBodyHome()
    },
  },
}
</script>

<style lang="scss">
.form-control-home {
  cursor: pointer;
  font-weight: bold;
}

.text-direction-homeCod {
  font-size: 17px;
}

.header-form-home {
  width: 100%;
}

.float-button {
  display: flex;
  width: 100%;
  flex-direction: row-reverse;
}

.text-direction {
  font-weight: bold;
}

.card-form-home {
  top: 5%;
}

.text-form-home {
  margin-top: 2%;
}

.text-codeHome {
  font-weight: bold;
}

.text-codeHome-container {
  background-color: blue;
}

.result-search-form-home {
  margin: 0px 0;
}

.button-modal-direccion {
  background-color: red;
}

.input-edit {
  display: flex;
  border-radius: 50%;
}

.direccionText {
  font-weight: bold;
}

.searchDirection {
  font-weight: bold;
  padding: 0px 62px 3px 0px;
}

.direccionText-search {
  font-weight: bold;
}

.infoError-text {
  font-weight: bold;
  text-align: center;
}

.title-home-report {
  color: #ad0808;
  font-size: 22px;
}

.info-text-reportHome {
  font-size: 14px;
  color: #000000;
}

.swal2-styled.swal2-confirm.swalBtnColor {
  color: #ffffff;
  border-radius: 2.25em;
  border: white;
  width: 27%;
  font-weight: bold;
  height: 70%;
}

.text-center-homeReport {
  text-align: center;
}

.direccion-text-homereport {
  width: 102%;
  position: absolute;
  justify-content: space-around;
  display: flex;
  font-weight: bold;
}
</style>
